<template>
  <svg
    class="custom-icon"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      stroke="rgb(var(--v-theme-primary))"
      fill="#ffffff"
      stroke-width="1"
      x="1.855426"
      y="0.855426"
      width="6.289148"
      height="6.289148"
      rx="2"
    />
  </svg>
</template>
